import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import _, { compact } from "lodash";
import { useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { IMPORT_REQUEST_EDITABLE_STATUS } from "../../../../constants/common";
import { download, Toast } from "../../../../modules/common/helper";
import ProductTable from "./ProductTable";
import { HeaderModel, ModalModel } from "../../../../models/CommonModel";
import { exportDetails, exportPdf, getDetail, updateRequest } from "../ImportRequestCRUD";
import DetailInfo from "./DetailInfo";
import { ImportRequestDetailModel, ImportRequestModel } from "../../../../models/ImportRequestModel";
import { openNewTabWithHtml } from "../../../../selectors";

const Detail: FC = () => {
  const intl = useIntl()
  const { id } = useParams<{ id?: string }>();
  const [detail, setDetail] = useState<ImportRequestModel>()
  const [originData, setOriginData] = useState<ImportRequestModel>()
  const [editable, setEditAble] = useState<boolean>(false)
  const [selected, setSelected] = useState<number[]>([])
  const [removeIds, setRemoveIds] = useState<number[]>([])
  const schema = Yup.object().shape({});
  const header: HeaderModel[] = [
    {
      label: intl.formatMessage({ id: 'PRODUCTS.NAME' }),
      field: 'name',
      style: { maxWidth: "180px", minWidth: "180px", },
      sortable: false
    },
    {
      label: 'Cửa hàng',
      field: 'store',
      style: { maxWidth: "180px", minWidth: "180px", },
      sortable: false
    },
    {
      label: 'Đơn giá',
      field: 'price',
      style: { maxWidth: "100px", minWidth: "100px", },
      sortable: false
    },
    {
      label: 'SL đặt',
      field: 'request_quantity',
      style: { maxWidth: "100px", minWidth: "100px", },
      sortable: false
    },
    {
      label: 'SL giao',
      field: 'quantity',
      style: { maxWidth: "100px", minWidth: "100px", },
      sortable: false
    },
    {
      label: 'VAT',
      field: 'vat',
      style: { maxWidth: "50px", minWidth: "50px", },
      sortable: false
    },
    {
      label: 'Tồn kho',
      field: 'warehouse',
      style: { maxWidth: "80px", minWidth: "80px", },
      sortable: false
    },
    {
      label: 'Ghi chú',
      field: 'note',
      style: { maxWidth: "150px", minWidth: "150px", },
      sortable: false
    }
  ]

  const [hideCols, setHideCols] = useState<string[]>([
    'warehouse'
  ]);
  const [configModal, setConfigModal] = useState<ModalModel>({
    show: false,
    mode: 'add',
  });

  useEffect(() => {
    document.title = 'Sento Supplier - Yêu cầu nhập hàng';
  })

  useEffect(() => {
    getDetailData();
  }, []);

  const getDetailData = async () => {
    const { data } = await getDetail(id);
    setDetail(data.data);
    setOriginData(data.data);
    setEditAble(IMPORT_REQUEST_EDITABLE_STATUS.includes(data.data?.status ?? ''));
  }

  const handleSubmit = async () => {
    try {
      if (detail && detail.id) {
        const { data } = await updateRequest(detail.id, detail, removeIds)
        Toast.fire({
          icon: 'success',
          title: data?.message || intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
        })
        getDetailData();
      }
    } catch (error: any) {
      Toast.fire({
        icon: 'error',
        title: error?.response?.data?.message,
      })
    }
  }
  const toggleCheck = (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => {
    let newSelected = [...selected];
    if (item.consign_product_id) {
      if (e.target.checked) {
        newSelected.push(item.consign_product_id);
      } else {
        newSelected = newSelected.filter(el => el !== item.consign_product_id)
      }
      setSelected(newSelected);
    }
    
  }
  const handleChangeQty = (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => {
    let requestDetails = [...detail?.details ?? []];
    let findIndex = requestDetails.findIndex(el => el.consign_product_id === item.consign_product_id);
    if (findIndex >= 0) {
      let originItem = {...originData?.details?.[findIndex]};
      let originQty = originItem.request_quantity ?? 0;
      let newQty = parseInt(e.target.value) > originQty ? item.quantity : parseInt(e.target.value);
      requestDetails[findIndex] = {
        ...requestDetails[findIndex],
        quantity: newQty
      }
    }
    setDetail({
      ...detail,
      details: requestDetails
    })
  }

  const handleChangeDetail = (e: any) => {
    setDetail({
      ...detail,
      [e.target.name]: e.target.value
    })
  }

  const handleExportPdf = async () => {
      if (detail?.id) {
        const {data: resData} = await exportPdf({id: detail.id})
        openNewTabWithHtml(resData);
      }
  }

  const handleExportCSV = async () => {
    if (detail?.id) {
      const {data} = await exportDetails(detail.id);
      download(data, `import-request-${detail.code}`);
    }
  }

  return (
    <Formik enableReinitialize validationSchema={schema}
      initialValues={{}} onSubmit={handleSubmit}>
      {({ values, handleChange }) => {
        return (
          <>
            <Form>
              <div className="card">
                <DetailInfo
                  detail={detail}
                  editable={editable}
                  handleChangeDetail={handleChangeDetail}
                  handleSubmit={handleSubmit}
                  handleExportPdf={handleExportPdf}
                  handleExportCSV={handleExportCSV}
                />
                <div className="card-body">
                  <ProductTable
                    importRequest={detail}
                    editable={editable}
                    handleChangeQty={handleChangeQty}
                    toggleCheck={toggleCheck}
                    openColConfig={() => setConfigModal({ ...configModal, show: true })}
                    hideCols={hideCols}
                    headers={header}
                    selected={selected}
                  />
                </div>
              </div>
            </Form>
          </>
        )
      }}
    </Formik>
  )
}
export default Detail;